import { Button } from '@/components/ui/button';

// The rep queues load by walking every cursor page (see lib/submission-pages.ts).
// fetchAllSubmissions() THROWS on a failed page rather than returning the rows
// it managed to read, because a short list that looks complete is the exact
// failure that module exists to remove. That means SWR's error state has to be
// rendered explicitly: without this, every one of these tabs falls through to
// its empty state and tells the rep there is no work — which is the same silent
// lie wearing a different hat.
export function QueueLoadError({ queue, onRetry }: { queue: string; onRetry: () => void }) {
  return (
    <div className="p-8 text-center text-[12px]">
      <div className="text-danger">Could not load {queue}.</div>
      <div className="mt-1 text-subtle">
        This is a load failure, not an empty queue — rows may exist that are not shown. Nothing was lost.
      </div>
      <Button variant="secondary" size="sm" className="mt-3" onClick={onRetry}>Try again</Button>
    </div>
  );
}
